import * as React from 'react';

const OktaNoAccount = () => {
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");

    return (
        <div className="preloaderColumn">
            <div className="rediret alert alert-info"> Okta is not configurated for this Fleet.</div>
        </div>
    );
};

export default OktaNoAccount;
